// @ts-nocheck - Legacy file with type issues requiring refactoring (TODO: GXM-XXXX)
import PropTypes from "prop-types";
import CustomeButton from "~/components/Button";
import { useNavigate, useParams } from "react-router-dom";
import AdminOnly from "~/components/AdminOnly";
export default function EmptyDataView({
  Icon,
  Header,
  Description,
  label,
  handleNavigate,
}) {
  return (
    <div className="flex flex-column justify-content-center align-items-center p-5 empty__data__view">
      {Icon && <div className="empty__data__view--icon">{Icon}</div>}
      {Header && <p className="empty__data__view--header">{Header}</p>}
      {Description && (
        <p className="empty__data__view--description">{Description}</p>
      )}
      <AdminOnly>
        <CustomeButton
          label={label}
          className="access-btn"
          icon="pi pi-plus"
          iconPos="right"
          onClick={handleNavigate}
        />
      </AdminOnly>
    </div>
  );
}
EmptyDataView.propTypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.node,
};
